import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section className="about-section" aria-labelledby="about-bsides">
      <h3 id="about-bsides">About BSides Bangalore</h3>
      <p>
        BSides Bangalore is a non-profit, community-driven cybersecurity conference dedicated to knowledge-sharing, collaboration, and volunteerism. Our mission is to empower the security community with hands-on learning and networking opportunities.
      </p>
    </section>
  );
};

export default AboutSection;